import template from './tooltipDesktop.html';
import controller from './tooltipDesktop.controller';

let tooltipDesktopComponent = {
  restrict: 'E',
  bindings: {
    placement: '@',
    title: '@'
  },
  template,
  controller
};

export default tooltipDesktopComponent;



// WEBPACK FOOTER //
// ./client/app/components/tooltipDesktop/tooltipDesktop.component.js